import type React from 'react';
import SvgIcon from './SvgIcon';

const DoorDashSvg: React.FC = ({
  ariaLabel,
}:{
  ariaLabel?: string;
}) => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-label={ariaLabel}
  >
    <path
      d="M21.2262 9.00739C20.7923 8.19221 20.1442 7.5109 19.3516 7.03687C18.5591 6.56284 17.6522 6.31406 16.7288 6.31735H2.48642C2.38988 6.31817 2.29573 6.34745 2.21575 6.40153C2.13578 6.45562 2.07354 6.5321 2.03684 6.62139C2.00013 6.71069 1.99059 6.80883 2.00941 6.90352C2.02823 6.99821 2.07457 7.08524 2.14263 7.15372L5.24482 10.274C5.38053 10.4104 5.54187 10.5187 5.71956 10.5925C5.89726 10.6664 6.0878 10.7043 6.28022 10.7043H16.3206C16.4907 10.7025 16.6594 10.7343 16.8171 10.7978C16.9749 10.8613 17.1185 10.9552 17.24 11.0742C17.3614 11.1933 17.4582 11.335 17.5249 11.4915C17.5916 11.6479 17.6267 11.8159 17.6285 11.9859C17.6302 12.156 17.5984 12.3247 17.5349 12.4824C17.4714 12.6402 17.3775 12.7839 17.2585 12.9053C17.1395 13.0267 16.9977 13.1236 16.8413 13.1902C16.6848 13.2569 16.5168 13.2921 16.3468 13.2938H9.42464C9.32792 13.2942 9.23349 13.3232 9.15322 13.3771C9.07294 13.4311 9.01039 13.5075 8.97344 13.5969C8.93648 13.6863 8.92677 13.7846 8.94553 13.8794C8.96428 13.9743 9.01066 14.0615 9.07883 14.1301L12.183 17.2524C12.3187 17.3889 12.48 17.4972 12.6577 17.5711C12.8354 17.6449 13.026 17.6829 13.2184 17.6827H16.3488C20.422 17.6827 23.5021 13.3279 21.2262 9.00538"
      fill="currentColor"
    />
  </SvgIcon>
);

export default DoorDashSvg;
